<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'accept'">Duyệt điểm đến</span>
        <span v-if="mData.viewMode == 'update'">Cập nhật điểm đến chờ duyệt</span>
        <span v-if="mData.viewMode == 'create'">Tạo mới điểm đến chờ chuyệt</span>
        <span v-if="mData.viewMode == 'detail'">Chi tiết điểm đến chờ duyệt</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="4">
              <el-form-item label="Tên" prop="diem_den.ten">
                <el-input v-model="mData.dataForm.diem_den.ten" :disabled="
                  mData.viewMode == 'accept' || mData.viewMode == 'detail'
                " clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Tên đơn vị" prop="">
                <el-input v-model="mData.dataForm.thong_tin_chung.ten" :disabled="true" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Email" prop="">
                <el-input v-model="mData.dataForm.thong_tin_chung.email" :disabled="true" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Điện thoại" prop="">
                <el-input v-model="mData.dataForm.thong_tin_chung.dien_thoai" :disabled="true" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="8">
              <el-form-item label="Địa chỉ" prop="">
                <el-input v-model="mData.dataForm.thong_tin_chung.dia_chi" :disabled="true" clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Ngôn ngữ" prop="" class="label-required">
                <el-select v-model="mData.dataForm.ngon_ngu" :placeholder="aLang.c_select" disabled clearable
                  filterable>
                  <el-option v-for="item in mData.dataDefault.listNgonNgu" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Loại hình ưu đãi" prop="loai_hinh_uu_dai">
                <el-select v-model="mData.dataForm.loai_hinh_uu_dai" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" clearable filterable
                  @change="fn_selectTypeEndow(mData.dataForm.loai_hinh_uu_dai)">
                  <el-option v-for="item in mData.dataDefault.listEndow" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputMoney">
              <el-form-item
                label="Giá trị ưu đãi VND"
                prop="gia_tri_uu_dai"
                :rules="rulesGiaTriUuDai"
              >
                <ElementUiMoney
                  :value="mData.dataForm.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="
                    mData.viewMode == 'accept' || mData.viewMode == 'detail'
                  "
                  :clearable="true"
                  @input="handleInputGiaTriUuDai"
                />
              </el-form-item>
            </b-col>
            <b-col md="3" v-if="showInputPercent">
              <el-form-item
                label="Giá trị ưu đãi %"
                prop="gia_tri_uu_dai"
                :rules="rulesGiaTriUuDaiPercent"
              >
                <el-input
                  v-model="mData.dataForm.gia_tri_uu_dai"
                  placeholder="Nhập giá trị ưu đãi"
                  :disabled="
                    mData.viewMode == 'accept' || mData.viewMode == 'detail'
                  "
                  clearable
                  @input="handleInputGiaTriUuDai"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" lg="3" cols="12" v-for="item in mData.dataForm.link_dich_vu" :key="item.id">
              <el-form-item :label="'Link ' + (item.ten ? item.ten : '')" prop="">
                <el-input v-model="item.link" :disabled="
                  mData.viewMode == 'accept' || mData.viewMode == 'detail'
                " @input="forceUpdateUI" clearable></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="diem_den.anh_hien_thi">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="
                    mData.viewMode == 'accept' || mData.viewMode == 'detail'
                  " :class="[
  mData.fileUploadOption.AnhDaiDien.fileList.length > 0
    ? 'hidden-icon-upload'
    : '',
]">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="
                  mData.fileUploadOption.AnhDaiDien.dialogVisible
                " width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
            <b-col md="10">
              <b-col md="6" v-if="getStatusName">
                <label class="el-form-item__label">Trạng thái:</label>
                <span style="font-size: 14px; padding: 0.4em 0.4em;" class="badge badge-pill ml-2" :class="{
                  'badge-secondary': getStatusName == 'Từ chối',
                  'badge-primary': getStatusName == 'Chờ duyệt',
                  'badge-info': getStatusName == 'Đang soạn thảo'
                }">{{ getStatusName }}</span>
              </b-col>
              <b-col md="12" v-if="mData.dataForm.ly_do_tu_choi">
                <el-form-item label="Lý do từ chối" prop="dich_vu.ly_do_tu_choi">
                  <el-input v-model="mData.dataForm.ly_do_tu_choi" type="textarea" :rows="5" disabled
                    clearable></el-input>
                </el-form-item>
              </b-col>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Giới thiệu" prop="diem_den.mo_ta">
                <el-input v-model="mData.dataForm.diem_den.mo_ta"
                  :disabled="mData.viewMode == 'accept' || mData.viewMode == 'detail'" @input="forceUpdateUI"
                  type="textarea" :rows="2" clearable></el-input>
                <!-- <CknoimgComponent
                  v-model="mData.dataForm.diem_den.mo_ta"
                  :prop-data-editor-disabled="
                    mData.viewMode == 'accept' || mData.viewMode == 'detail'
                  "
                  @blur="handleBlur('diem_den.mo_ta')"
                ></CknoimgComponent> -->
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Chi tiết" prop="diem_den.chi_tiet">
                <CknoimgComponent v-model="mData.dataForm.diem_den.chi_tiet" :prop-data-editor-disabled="
                  mData.viewMode == 'accept' || mData.viewMode == 'detail'
                " @blur="handleBlur('diem_den.chi_tiet')"></CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Album" prop="dich_vu.thong_tin_chung.album_anh">
                <el-upload action :auto-upload="false" drag :accept="mData.albumUploadOption.accept"
                  :on-change="handleUploadAlbum" :on-preview="handlePreviewAlbum" :on-remove="handleRemoveAlbum"
                  :file-list="mData.albumUploadOption.fileList"
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'accept'" multiple list-type="picture">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Kéo thả ảnh vào đây hoặc <em>click để upload</em></div>
                </el-upload>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda v-if="
              mData.viewMode == 'create' &&
              (mData.currentUser.roles.includes('Officer') ||
                mData.currentUser.roles.includes('Admin'))
            ">Tạo mới</el-button>
            <el-button type="danger" plain @click="fn_submitForm('not-accept')" v-ladda v-if="
              mData.viewMode == 'accept' &&
              mData.dataForm.ready == true &&
              (mData.currentUser.roles.includes('Officer') ||
                mData.currentUser.roles.includes('Admin'))
            ">Từ chối</el-button>
            <el-button type="success" plain @click="fn_submitForm('accept')" v-ladda v-if="
              mData.viewMode == 'accept' &&
              mData.dataForm.ready == true &&
              (mData.currentUser.roles.includes('Officer') ||
                mData.currentUser.roles.includes('Admin'))
            ">Duyệt</el-button>
            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="mData.viewMode == 'update'">Cập
              nhật</el-button>
            <el-button type="info" plain @click="fn_submitForm('sendApprove')" v-ladda
              v-if="mData.viewMode == 'update' && mData.currentUser.roles.includes('SafePlace')">Gửi</el-button>
            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-image-viewer v-if="mData.albumUploadOption.dialogVisible" :on-close="closeViewer" :url-list="mData.urlImage" />
    <ModalReson :isShow="modal.showResonUpdateModal" :dataObject="mData.dataForm" />
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from '@/service/DataService';
import MethodService from "../../../service/MethodService";
import DiemDenModel from '@/views/admin/DiemDen/DiemDenModel';
import ShareDichVuModel from "@/views/admin/ShareModel/ShareDichVuModel";
import NenTangDichVuApi from "@/moduleApi/NenTangDichVuApi";
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import ModalReson from '@/views/admin/VuiChoiGiaiTri/ModalReson';
import DichVuChoDuyetApi from "@/moduleApi/DichVuChoDuyetApi";
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
import DDATApi from "@/moduleApi/DDATApi";
import ValidService from "@/service/ValidService";
import ElementUiMoney from '@/component/ElementUiMoney';
import FileApi from '@/moduleApi/FileApi';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
  components: {
    CknoimgComponent,
    ElementUiMoney,
    ModalReson,
    ElImageViewer
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DiemDen",
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        urlImage: [],
        dataDefault: {
          listProvince: [],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          listEndow: DataService.endowList,
        },
        dataForm: MethodService.copyObject(DiemDenModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          DiemDenModel.dataFormOther.fileUploadOption
        ),
        albumUploadOption: MethodService.copyObject(
          ShareDichVuModel.albumUploadOption
        ),
        validForm: DiemDenModel.validForm,
      },
      modal: {
        showResonUpdateModal: false,
      },
      showInputMoney: false,
      showInputPercent: false,
      rulesGiaTriUuDai: [ValidService.checkGiaTriUuDaiVND(1000)],
      rulesGiaTriUuDaiPercent: [ValidService.checkGiaTriUuDaiPercent(1, 100)],
    };
  },

  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-accept"
    ) {
      this.mData.viewMode = "accept";
    } else if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update-history"
    ) {
      this.mData.viewMode = "update";
    } else if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-create-history"
    ) {
      this.mData.viewMode = "create";
    } else {
      this.mData.viewMode = "detail";
    }
    if ((this.mData.viewMode == "create")) {
      this.fn_getDonViCungCapById(this.$router.currentRoute.params.id);
    } else {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  async mounted() {
    if (this.mData.viewMode == "create") {
      const dataCheck = await this.fn_checkServiceExist(
        this.$router.currentRoute.params.id
      );
      if (dataCheck) {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update-history",
          params: { id: dataCheck.id },
        });
      }
    }
  },
  methods: {
    async fn_checkServiceExist(diem_den_an_toan_id) {
      const res = await DichVuChoDuyetApi.list({
        filters: [
          "loai=yellow_page_place",
          "diem_den_an_toan_id=" + diem_den_an_toan_id,
        ],
      });
      if (res.result.length) {
        return res.result[0];
      } else {
        return null;
      }
    },
    async fn_submitForm(type) {
      if (type == "create") {
        const dataCheck = await this.fn_checkServiceExist(
          this.$router.currentRoute.params.id
        );
        if (dataCheck) {
          this.$router.push({
            name: "Admin-" + this.mData.moduleName + "-update-history",
            params: { id: dataCheck.id },
          });
          return;
        }
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            let data = MethodService.copyObject(this.mData.dataForm);
            data.diem_den_an_toan_id = this.$router.currentRoute.params.id;
            try {
              await DichVuChoDuyetApi.create(data);
              toastr.success("Thêm mới thành công");
              this.fn_go();
            } catch (error) {
              toastr.error(error.detail, null, {
                timeOut: 0,
              });
            }
          }
        });
      } else if (type === "not-accept") {
        this.$confirm("Xác nhận từ chối dịch vụ này?", {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.modal.showResonUpdateModal = true;
          })
          .finally(() => {
            MethodService.stopLadda();
          });
      } else if (type == "sendApprove") {
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            let data = MethodService.copyObject(this.mData.dataForm);
            let uu_dai = null;
            if (this.mData.dataForm.loai_hinh_uu_dai) {
              uu_dai = this.mData.dataForm.gia_tri_uu_dai + this.mData.dataForm.loai_hinh_uu_dai;
            }
            data.duyet = {
              duoc_duyet: null
            };
            data.ready = true;
            data.uu_dai = uu_dai;
            await DichVuChoDuyetApi.updateSend(data);
            this.fn_go();
            this.$store.commit("fn_countDiemDen");
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      } else {
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            let data = MethodService.copyObject(this.mData.dataForm);
            let uu_dai = null;
            if (this.mData.dataForm.loai_hinh_uu_dai == "%") {
              uu_dai = this.mData.dataForm.gia_tri_uu_dai + this.mData.dataForm.loai_hinh_uu_dai;
            } else {
              uu_dai = this.mData.dataForm.gia_tri_uu_dai;
            }
            if (type === "accept") {
              this.$confirm("Xác nhận duyệt dịch vụ này?", {
                confirmButtonText: LanguageService.lang.c_agree,
                cancelButtonText: LanguageService.lang.c_cancel,
                type: "warning",
              })
                .then(async () => {
                  /* Read more about isConfirmed, isDenied below */
                  data.duyet = {
                    duoc_duyet: true,
                  };
                  try {
                    await DichVuChoDuyetApi.approvedDichVu(data);
                    this.fn_go();
                    this.$store.commit("fn_countDiemDen");
                  } catch (error) {
                    toastr.error(error.detail, null, {
                      timeOut: 0,
                    });
                    MethodService.stopLadda();
                  }
                })
                .finally(() => {
                  MethodService.stopLadda();
                });
            } else {
              try {
                if (
                  this.mData.currentUser.roles.includes('Admin') ||
                  this.mData.currentUser.roles.includes('Officer')
                ) {
                  data.duyet = {
                    duoc_duyet: null
                  };
                  data.uu_dai = uu_dai;
                  await DichVuChoDuyetApi.update(data);
                } else if (this.mData.currentUser.roles.includes('SafePlace')) {
                  data.duyet = {
                    duoc_duyet: null
                  };
                  data.ready = false;
                  data.uu_dai = uu_dai;
                  await DichVuChoDuyetApi.safePlaceUpdate(data);
                }
                this.$store.commit("fn_countDiemDen");
                this.fn_go();
              } catch (error) {
                toastr.error(error.detail, null, {
                  timeOut: 0,
                });
                MethodService.stopLadda();
              }
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        DiemDenModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },
    async fn_getDataById(id) {
      let dich_vu = await DichVuChoDuyetApi.findById(id);
      if (dich_vu.result) {
        let donViCungCapRes = await DonViCungCapApi.list({
          filters: "id=" + dich_vu.result.diem_den_an_toan_id,
        });
        const thongTinDiemDenAnToan = await DDATApi.list({
          filters: "id:in:" + donViCungCapRes.result[0].id,
        });
        let address = "";
        if (thongTinDiemDenAnToan.result[0].thong_tin_chung.dia_chi.dia_chi) {
          address +=
            thongTinDiemDenAnToan.result[0].thong_tin_chung.dia_chi.dia_chi;
        }
        const thong_tin_chung = {
          ten: donViCungCapRes.result[0].du_lieu_khai_bao.user_ten,
          dia_chi: address,
          dien_thoai:
            donViCungCapRes.result[0].du_lieu_khai_bao.user_dien_thoai, // required Điện thoại liên hệ khu giải trí
          email: donViCungCapRes.result[0].du_lieu_khai_bao.email, // optional Email liên hệ khu giải trí
          website: donViCungCapRes.result[0].du_lieu_khai_bao.website, // optional Website giới thiệu khu giải trí
          doi_tuong: donViCungCapRes.result[0].du_lieu_khai_bao.user_loai, // optional Đối tượng khách hàng hướng tới
        };
        this.mData.dataForm = dich_vu.result;
        let loaiHinhUuDai = undefined;
        let giaTriUuDai = "";
        if (dich_vu.result.uu_dai) {
          loaiHinhUuDai = dich_vu.result.uu_dai.substr(dich_vu.result.uu_dai.length - 1);
          giaTriUuDai = dich_vu.result.uu_dai.substr(0, dich_vu.result.uu_dai.length - 1);
          if (loaiHinhUuDai == "K") {
            this.showInputMoney = true;
            this.showInputPercent = false;
          } else if (loaiHinhUuDai == "%") {
            this.showInputMoney = false;
            this.showInputPercent = true;
          }
        }
        this.$set(this.mData.dataForm, "loai_hinh_uu_dai", loaiHinhUuDai);
        this.$set(this.mData.dataForm, "gia_tri_uu_dai", giaTriUuDai);
        this.mData.dataForm.thong_tin_chung = thong_tin_chung;
        this.mData.dataForm.tinh_thanh =
          thongTinDiemDenAnToan.result[0].thong_tin_chung.dia_chi.tinh;
        let nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Điểm đến&hien_thi=true",
        });
        if (nen_tang_dich_vu.result) {
          for (const element of nen_tang_dich_vu.result) {
            if (
              dich_vu.result.link_dich_vu &&
              dich_vu.result.link_dich_vu.find(
                (x) => x.id == element.id
              )
            ) {
              element.link = dich_vu.result.link_dich_vu.find(
                (x) => x.id == element.id
              ).link;
            } else {
              element.link = "";
            }
          }
        }
        this.mData.dataForm.link_dich_vu = nen_tang_dich_vu.result;

        if (dich_vu.result.diem_den.anh_hien_thi) {
          let data = {
            id: dich_vu.result.diem_den.anh_hien_thi,
            name: dich_vu.result.diem_den.anh_hien_thi,
            url: ExtensionService.urlImg + dich_vu.result.diem_den.anh_hien_thi,
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList = [];
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        if (
          dich_vu.result.thong_tin_chung &&
          dich_vu.result.thong_tin_chung.album_anh &&
          dich_vu.result.thong_tin_chung.album_anh.length > 0
        ) {
          let arrFileIds = [];
          dich_vu.result.thong_tin_chung.album_anh.forEach(x => {
            arrFileIds.push(x.anh_id);
          })
          const fileList = await FileApi.list({
            filters: "id:in:" + arrFileIds.join(",")
          })
          dich_vu.result.thong_tin_chung.album_anh.forEach(e => {
            let fileName = fileList.result.find(y => y.id == e.anh_id)
            let data = {
              id: e.anh_id,
              name: fileName.name,
              url: ExtensionService.urlImg + e.anh_id
            };
            this.mData.albumUploadOption.fileList.push(data);
            this.mData.urlImage.push(data.url);
          })
        } else {
          this.mData.dataForm.dich_vu.thong_tin_chung = {
            album_anh: []
          };
        }
      }
      this.$forceUpdate();
    },

    fn_selectTypeEndow(e) {
      if (e == "K") {
        this.showInputMoney = true;
        this.showInputPercent = false;
      } else if (e == "%") {
        this.showInputMoney = false;
        this.showInputPercent = true;
      } else {
        this.showInputMoney = false;
        this.showInputPercent = false;
      }
      this.$set(this.mData.dataForm, "gia_tri_uu_dai", "");
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("gia_tri_uu_dai");
        }
      });
    },
    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.diem_den.anh_hien_thi = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("diem_den.anh_hien_thi");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "giaiTri")
        .then((res) => {
          this.mData.dataForm.diem_den.anh_hien_thi = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("diem_den.anh_hien_thi");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("diem_den.anh_hien_thi");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    //Album
    handleUploadAlbum(file, fileList) {
      if (file.raw.type != "image/jpeg" && file.raw.type != "image/png") {
        toastr.info("Vui lòng tải lên ảnh có định dạng .jpeg, .jpg hoặc .png");
        fileList.forEach((el, i) => {
          if (el.uid == file.uid) {
            fileList.splice(i, 1);
          }
        });
        return
      }
      ExtensionService.upload(file, "Album")
        .then((res) => {
          this.mData.dataForm.dich_vu.thong_tin_chung.album_anh.push(
            {
              anh_id: res.result
            }
          );
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.albumUploadOption.fileList = fileList;
          this.mData.albumUploadOption.fileList.forEach((item) => {
            this.mData.urlImage.push(item.url);
          });
        })
        .catch((error) => {
          console.info("error", error);
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    handleRemoveAlbum(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.dich_vu.thong_tin_chung.album_anh = data;
    },
    handlePreviewAlbum() {
      this.mData.albumUploadOption.dialogVisible = true;
    },
    getListImage(arrFileIds) {
      arrFileIds.forEach((item) => {
        let url = this.imgUrl + item.anh_id.id;
        this.mData.urlImage.push(url);
      });
    },
    closeViewer() {
      this.mData.albumUploadOption.dialogVisible = false;
    },
    handleInputGiaTriUuDai(val) {
      this.$set(this.mData.dataForm, "gia_tri_uu_dai", val);
      if (this.$refs["myForm"]) {
        this.$refs["myForm"].clearValidate("gia_tri_uu_dai");
      }
      this.forceUpdateUI();
    },
  },
  computed: {
    getStatusName() {
      if (this.mData.dataForm.ready) {
        return "Chờ duyệt";
      } else if (!this.mData.dataForm.duyet.duoc_duyet) {
        return "Từ chối";
      } else if (!this.mData.dataForm.ready) {
        return "Đang soạn thảo";
      } else {
        return "";
      }
    },
  },
};
</script>
